import { render } from "./ChooseUs.vue?vue&type=template&id=7a1e4160&scoped=true"
import script from "./ChooseUs.vue?vue&type=script&lang=js"
export * from "./ChooseUs.vue?vue&type=script&lang=js"

import "./ChooseUs.vue?vue&type=style&index=0&id=7a1e4160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a1e4160"]])

export default __exports__